define('models/pages/trade/basket-items',['require','models/base/collection','./basket-item'],function(require) {
    'use strict';

    var Collection = require('models/base/collection');
    var BasketItem = require('./basket-item');

    var BasketItemsCollection = Collection.extend({
        model: BasketItem
    });

    return BasketItemsCollection;
});
